module.exports = __webpack_public_path__ + "static/img/tphtitle.5603793a.jpg";